import styled, { keyframes } from "styled-components";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const StyledContacts = styled.div<{ $isVisible: boolean }>`
  min-height: calc(100vh - 70px);
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  animation: ${(props) => (props.$isVisible ? fadeInUp : "none")} 0.6s ease-out;
`;
